module.exports = __webpack_public_path__ + "images/emoji/cop.a2439e33191cf83111c2.png";